import { observer } from "mobx-react-lite";
import { FC } from "react";
import { ImageUploadRejectedModalStore } from "@/components/modal/image-upload-rejected/image-upload-rejected-modal-store";
import {
  MDSButton,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import { MDSButtonGroup } from "@/mds/components/buttons/button-group";

export interface ImageUploadRejectedModalProps {
  store: ImageUploadRejectedModalStore;
}

export const ImageUploadRejectedModal: FC<ImageUploadRejectedModalProps> = observer(({ store }) => {
  return (
    <MDSModalDialog isOpen={store.isOpen} handleClose={() => store.close()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        {store.isTooLarge ? "This image is too large to upload" : "Upload failed"}
      </MDSText>
      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        {store.isTooLarge ? (
          <MDSText variant={MDSTextVariant.ParagraphSm}>
            <MDSText as="span" variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Medium}>
              {store.truncatedImageName}
            </MDSText>{" "}
            exceeds the {store.imageSizeLimitMb}MB file size limit. Try compressing the image or
            using a smaller version.
          </MDSText>
        ) : (
          <MDSText variant={MDSTextVariant.ParagraphSm}>
            Failed to upload{" "}
            <MDSText as="span" variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Medium}>
              {store.truncatedImageName}
            </MDSText>
            . An error occurred while uploading the image. Please try again.
          </MDSText>
        )}
      </MDSDialogTextContent>
      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton variant={MDSButtonVariant.Contrast} onClick={() => store.close()}>
          Got it
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
